$(document).ready(function ()
{
  var app = new Vue(
    {
      el: "#body-container",
      data:
        {
          images: model.images,
          documents: model.documents
        },
      mounted: function()
      {
        clearLoading();

        if (this.images && this.images.length && this.images.length > 0)
        {
          $(".thumbnails .thumbnail-container a").on("click", function(event)
          {
            event.preventDefault();
            $(this).ekkoLightbox();
          });
        }
      },
      computed:
        {
          hasImages: function()
          {
            if (this.images && this.images.length && this.images.length > 0)
            {
              return true;
            }

            return false;
          },
          hasDocuments: function()
          {
            if (this.documents && this.documents.length && this.documents.length > 0)
            {
              return true;
            }

            return false;
          }
        }
    });
});